import { render, staticRenderFns } from "./TransfSalesman.vue?vue&type=template&id=6c0ba270"
import script from "./TransfSalesman.vue?vue&type=script&lang=js"
export * from "./TransfSalesman.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports